import React from 'react'

function ControlPage() {
    return (
        <div className='container-fluid'>
            <div className='row mt-3'>
                <div className='col-md-12'>
                    <div className='alert alert-danger' role='alert'>
                        Bu sayfaya erişim yetkiniz bulunmamaktadır.
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ControlPage